/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100SetupCombinationsException } from './Ptw100SetupCombinationsException';
import {
    Ptw100SetupCombinationsExceptionFromJSON,
    Ptw100SetupCombinationsExceptionFromJSONTyped,
    Ptw100SetupCombinationsExceptionToJSON,
} from './Ptw100SetupCombinationsException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100SetupCombinationsException
 */
export interface ErrorResponseOfPtw100SetupCombinationsException {
    /**
     * This code is used in the ExceptionMiddleware and will be set as the HTTP response status code
     * @type {number}
     * @memberof ErrorResponseOfPtw100SetupCombinationsException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100SetupCombinationsException}
     * @memberof ErrorResponseOfPtw100SetupCombinationsException
     */
    exception: Ptw100SetupCombinationsException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100SetupCombinationsException
     */
    $type?: ErrorResponseOfPtw100SetupCombinationsExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100SetupCombinationsExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroApplicationSharedExceptionsPtw100SetupCombinationsExceptionPtwPtw100AppZeroApplicationSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Application.Shared.Exceptions.Ptw100SetupCombinationsException, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100SetupCombinationsExceptionTypeEnum = typeof ErrorResponseOfPtw100SetupCombinationsExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100SetupCombinationsExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100SetupCombinationsException interface.
 */
export function instanceOfErrorResponseOfPtw100SetupCombinationsException(value?: unknown): value is ErrorResponseOfPtw100SetupCombinationsException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100SetupCombinationsExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100SetupCombinationsExceptionFromJSON(json: any): ErrorResponseOfPtw100SetupCombinationsException {
    return ErrorResponseOfPtw100SetupCombinationsExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100SetupCombinationsExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100SetupCombinationsException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100SetupCombinationsExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100SetupCombinationsExceptionToJSON(value?: Omit<ErrorResponseOfPtw100SetupCombinationsException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100SetupCombinationsExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

